// The infoscreen list lives on the Settings page
export const INFOSCREENS_LIST_PATH = '/settings?tab=infoscreens';
